<template>
  
<v-app light>
  <v-toolbar class="white">
    <v-toolbar-title class="mx-0" v-text="title"></v-toolbar-title>
    <p>Beta</p>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <!-- <v-btn flat>Open jobs</v-btn> -->
      
      <v-btn text @click='changeLocale()'> {{lang}}  </v-btn>
      <v-btn text class="pink lighten-3" @click="$router.push( 'login' )">Sign In</v-btn>
    </v-toolbar-items>
  </v-toolbar>
  <v-content>
    <section>
      
      
      <v-parallax :src="require( '@/assets/home/employee_shiftmanage.jpg' )" height="600">
        <v-layout column align-center justify-center class="white--text">
          <h1 class="black--text mb-2 display-1 text-xs-center" style="font-weight: 900; text-shadow: 4px 3px #FFFFFF">{{$t( "home.main_title")}}</h1>
          <div class="black--text subheading mb-3 text-xs-center" style="font-weight: 900; text-shadow: 2px 2px #FFFFFF">{{$t( "home.main_subtitle")}}</div>
          <v-btn class="blue lighten-2 mt-5" dark large @click="$router.push( 'login' )">
            Get Started
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>
    
    <section>
      <v-layout column wrap class="my-5" align-center >
        
        <v-flex xs12 sm4 class="my-3">
          <div class="text-xs-center">
            <h2 class="headline" align="center"><b>{{ $t( "home.leading_title" ) }}</b></h2>
            <span class="subheading center mx-5 mt-2">
              {{ $t( "home.leading_content1" ) }}<br>
              {{ $t( "home.leading_content2" ) }}
            </span>
          </div>
        </v-flex>
        
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-row>
              <v-col cols="12" md="4" v-for="(item, index) in topicIcons" :key=index>
                <v-card class="elevation-0 transparent">
                  <v-card-title primary-title class="layout justify-center">
                    <v-icon x-large class="mr-3 blue--text text--lighten-2">{{item}}</v-icon>
                    <div class="headline text-xs-center"> {{ $t( "home.topic"+(index+1)+"_title" ) }}</div>
                  </v-card-title>
                  <v-card-text align="center"> 
                    {{ $t( "home.topic"+(index+1)+"_content1" ) }}<br>
                    {{ $t( "home.topic"+(index+1)+"_content2" ) }}<br>
                    {{ $t( "home.topic"+(index+1)+"_content3" ) }}<br>                    
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            
          </v-container>
          
        </v-flex>
        <v-flex xs12 sm4 class="my-3">
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div class="headline">{{ $t( "home.mainvideo_title" ) }}</div>
            </v-card-title>
            
            <div class="video-container" >
              <iframe  src="https://www.youtube.com/embed/RzuH4k4bfls?cc_load_policy=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;;" allowfullscreen></iframe>
            </div>
          </v-card>
        </v-flex>
        
      </v-layout>
    </section>
    
    <section>
      <v-parallax :src="require( '@/assets/home/Shift_Schedule_out.jpg' )" height="380">
        
        <v-layout column align-center justify-center>
          <div class="headline black--text mb-3 text-xs-center">{{ $t( "home.secondleading_title" ) }}</div>
          <em class="black--text">{{ $t( "home.secondleading_subtitle" ) }}</em>
          <v-btn class="blue lighten-2 mt-5" dark large href="/login">
            今すぐ始める
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>
    
    <section>
      <v-container grid-list-md>
        
        <v-layout row wrap>
          <v-flex xs12 text-xs-center class="mt-5" v-for="(item, index) in secondtopicIcons" :key=index>
            <div class="headline"><v-icon x-large class="mr-3 blue--text text--lighten-2">{{ item }}</v-icon>{{ $t( "home.secondtopic"+(index+1)+"_title" ) }}</div>
            <br>
            <div class="mx-5">{{ $t( "home.secondtopic"+(index+1)+"_content1" ) }}<br>
              {{ $t( "home.secondtopic"+(index+1)+"_content2" ) }}</div>
          </v-flex>
          
          <!-- <v-flex xs8 offset-xs2> -->
            <!--     <v-card class="elevation-0 transparent"> -->
              <!--       <v-card-text> -->
                <!--         <v-flex xs12 > <v-text-field box label="件名"></v-text-field> </v-flex> -->
                <!--         <v-flex xs12 > <v-text-field box label="メールアドレス" :rules="emailRules" v-model="email" hint="Enter your email!" persistent-hint></v-text-field> </v-flex> -->
                <!--         <v-flex xs12 > <v-text-field box multi-line label="質問事項"></v-text-field> </v-flex> -->
                <!--         <v-flex xs12 class="text-xs-center" > <v-btn class="blue lighten-2 mb-5" dark large @click="subscribe">Get in touch</v-btn></v-flex> -->
                <!--       </v-card-text> -->
              <!--     </v-card> -->
            <!-- </v-flex> -->
          
        </v-layout>
      </v-container>
    </section>
    
    <section>
      
      <v-parallax :src="require( '@/assets/home/ShiftPro_out.jpg' )" height="380">
        <v-layout column align-center justify-center>
          <div class="headline black--text mb-3 text-xs-center">{{ $t( "home.thirdleading_title" ) }}</div>
          <em class="black--text"> {{ $t( "home.thirdleading_subtitle" ) }}</em>
        </v-layout>
        <v-layout justify-space-around justify-center>
          <v-icon x-large dark>fab fa-facebook-f</v-icon>
          <v-icon x-large dark>fab fa-twitter</v-icon>
          <v-icon x-large dark>fab fa-reddit-alien</v-icon>
          <v-icon x-large dark>fab fa-instagram</v-icon>
          <v-icon x-large dark>fab fa-discord</v-icon>
        </v-layout>
      </v-parallax>
    </section>
    
    <section>
      <v-container grid-list-xl>
        <v-row>
          <v-col class="pa-10" cols="12" md="6" v-for="n in 4" :key=n>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">{{ $t( "home.explainvideo"+ n +"_title" ) }}</div>
              </v-card-title>
              <!-- <v-card-text> -->
                <!--   下記の運営会社を参照ください。 -->
                <!-- </v-card-text> -->
              <div class="video-container" >
                <iframe :src="$t( 'home.explainvideo'+n+'_url' )" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;;" allowfullscreen></iframe>
              </div>
              <span class="subheading ma-5">
                {{ $t( "home.explainvideo"+n+"_content" ) }}
              </span>
              
            </v-card>
          </v-col>
          
        </v-row>
      </v-container>
    </section>
    
    <!-- <section> -->
      <!--  <v-container> -->
        <!--    <v-layout> -->
          <!--    </v-layout> -->
        <!--  </v-container> -->
      <!-- </section> -->
    
  </v-content>
</v-app>
</template>

<script>
export default {
    name: "App",
    data: function() {
        return {
            lang: "English",
            topicIcons: [ 'mdi-web-clock', 'mdi-devices', 'mdi-security'],
            secondtopicIcons: [ 'mdi-clock-outline', 'mdi-hand-left', 'mdi-robot', 'mdi-calendar-blank-multiple', 'mdi-information-variant' ],
            title: "AllShifter",
            imageLink: {
                main: "@/assets/home/Shift_Schedule.jpg",
                sub_main: "https://i1.wp.com/throughapps.com/wp-content/uploads/2020/07/SHIFT-MANAGEMENT-1.png",
                logo: "../assets/home/bearlogo.jpg",
                social_cover: "https://advancesystems.ie/wp-content/uploads/2017/10/4-Smart-Tips-to-Manage-Employee-Schedules-Like-a-Pro.jpg"
                
            },
            email: "",
            emailRules: [
                v => {
                    return !!v || "E-mail is required";
                },
                v =>
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "E-mail must be valid"
            ],
            subscribed: false
        };
    },
    methods: {
        subscribe: function() {
            this.subscribed = !this.subscribed;
        },
        changeLocale() {
            
            this.$i18n.locale = (this.$i18n.locale === 'ja') ? 'en' : 'ja';
            this.lang = '日本語';
            if( this.$i18n.locale == 'ja' ){
                this.lang = 'English'
            }
            
        }        
    },
    
    computed: {
        imgHeight: function() {
            var offset = 320;
            console.log("new image height is " + (this.pageHeight - offset));
            return this.pageHeight - offset;
        }
    },
    
  mounted: function() {
      // this.calculateHeight();
  }
};
</script>

<style scoped>
.finedTitle {
    font-weight: 900;
    text-shadow: 2px 2px #000000;
}

.social-icon {
    font-size: 21px;
    color: white;
}

.center{
  display: block;
  text-align: center;
}
.video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
}
.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
